import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Centered "nothing here yet" message for an empty list/table. */
export function EmptyState({
  message,
  action,
  className,
}: {
  message: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-1 flex-col items-center justify-center gap-3 p-8 text-center text-muted-foreground",
        className,
      )}
    >
      <p className="text-sm italic">{message}</p>
      {action}
    </div>
  );
}
